
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.456 33.102c.5-2.3 1.1-5.4-1.6-6.3-1.5-.5-4.1 0-5.7 0h-23.6c-3.3 0-10.1-1.7-10.5 3-.7 8.1 5.2 14.9 12.3 18.3-.1 2-.5 5.2 1 6.2 1.6 1.1 5.7.3 7.6.3h5c.7 0 1.9.2 2.5-.2 1.5-.9 1.2-4.1 1.1-6.2 4.9-2.3 8.9-6.4 10.9-11.7.2-.2.3-.6.3-1 .3-.7.5-1.5.7-2.4zm-38.2-3.1c2-.5 4.8 0 6.9 0H40.357c2.2 0 5.2-.5 7.3 0 .8.2.8-.2 1.4.4.1.1.1.1.1.2h-3.7c-.7 0-.7 2.2 0 2.2h3.7c-.1.3-.2.5-.3.8h-38.1c-.1-.3-.2-.5-.3-.8h30.2c.7 0 .7-2.2 0-2.2h-30.1c.6-1 .7-.4 1.7-.6zm24.9 21.6c-.1-.1-.5-.2-.6-.2-2.1.3-4.5 0-6.6 0-2.1 0-4.4.3-6.5 0-.1 0-.6 0-.7.1 0-.4.1-1 .1-1.2v-1.7c2.4.9 4.8 1.5 7.2 1.6 2.5-.1 4.9-.6 7.2-1.4v1.3c-.1.1-.1 1.1-.1 1.5zm-7.2-4.5c-5.9-.2-11.5-2.5-15.3-7.2-.5-.6-1.4-1.8-2.3-3.2h35c-.7 1.2-1.4 2.2-1.8 2.7-3.8 5-9.4 7.5-15.6 7.7zM22.756 22.002c-2-3.2 1.3-5.1 1.6-8.1.2-2-.4-3.7-1.6-5.2-.8-1-1.3 2-.7 2.7 1.7 2-1.2 5-1.5 7.3-.3 2.2.4 4.1 1.5 6 .7 1 1.2-1.9.7-2.7zM30.256 18.502c-2-3.2 1.3-5.1 1.6-8.1.2-2-.4-3.7-1.6-5.2-.8-1-1.3 2-.7 2.7 1.7 2-1.2 5-1.5 7.3-.3 2.2.4 4.1 1.5 6 .6 1 1.2-2 .7-2.7zM37.657 22.602c-2-3.2 1.3-5.1 1.6-8.1.2-2-.4-3.7-1.6-5.2-.8-1-1.3 2-.7 2.7 1.7 2-1.2 5-1.5 7.3-.3 2.2.4 4.1 1.5 6 .6 1 1.2-1.9.7-2.7z"}})])
          )
        }
      }
    